var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "afil-legend" }, [
    _c("ul", [
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("edges.3")
            },
          },
        },
        [
          !_vm.legend.edges[3]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", [_vm._v("Рук-ль, УК")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("edges.4")
            },
          },
        },
        [
          !_vm.legend.edges[4]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", [_vm._v("Быв. руководитель")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("edges.5")
            },
          },
        },
        [
          !_vm.legend.edges[5]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", [_vm._v("Собственник")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("edges.6")
            },
          },
        },
        [
          !_vm.legend.edges[6]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", [_vm._v("Собственник (быв.)")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("edges.21")
            },
          },
        },
        [
          !_vm.legend.edges[21]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("div", [_vm._v("Предшественник")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("ul", [
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("nodes.1")
            },
          },
        },
        [
          !_vm.legend.nodes[1]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-building" }),
          _vm._v("\n            Юридическое лицо\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("nodes.2")
            },
          },
        },
        [
          !_vm.legend.nodes[2]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-user" }),
          _vm._v("\n            Индивидуальный предприниматель\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("nodes.3")
            },
          },
        },
        [
          !_vm.legend.nodes[3]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-globe" }),
          _vm._v("\n            Иностранное юридическое лицо\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("nodes.4")
            },
          },
        },
        [
          !_vm.legend.nodes[4]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-university" }),
          _vm._v("\n            Субъект РФ, ПИФ\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("nodes.5")
            },
          },
        },
        [
          !_vm.legend.nodes[5]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-male" }),
          _vm._v("\n            Физическое лицо\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("status.1")
            },
          },
        },
        [
          !_vm.legend.status[1]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__green",
          }),
          _vm._v("\n            Действущее\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("status.2")
            },
          },
        },
        [
          !_vm.legend.status[2]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__red",
          }),
          _vm._v("\n            Ликвидированое\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("status.3")
            },
          },
        },
        [
          !_vm.legend.status[3]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__orange",
          }),
          _vm._v("\n            В стадии ликвидации\n        "),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function ($event) {
              return _vm.toggleLegendRelations("status.4")
            },
          },
        },
        [
          !_vm.legend.status[4]
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__orange",
          }),
          _vm._v("\n            В стадии реорганизации\n        "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__upr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__lupr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__uchr" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("100%")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__luchr" },
      [
        _c("div", { staticClass: "afil-legend-edge__text" }, [
          _vm._v("(бывший)"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__predsh" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Предш")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }